import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TreeItem from '@material-ui/lab/TreeItem';
import { useTheme } from '@material-ui/core/styles';

import { onlyNumberRegexp } from 'lib/regexp/regexpConst';

import NewInput from 'components/atoms/NewInput';
import NewRadioGroup from 'components/molecules/NewRadioGroup';
import Modal from 'components/organisms/NewModal';

const MenuModal = (props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const {
    modal,
    handleModalClose = (f) => f,
    handleModalData = (f) => f,
    handleSubmit = (f) => f,
    mainMenuList,
    children,
    handleClickSnackbar,
    selectedMenu,
    parentMenu,
    menuArray,
  } = props;
  const type = modal['type'];
  const [error, setError] = useState({
    menuNm: { flag: false, message: null },
    menuSortNo: { flag: false, message: null },
    hirnkSeq: { flag: false, message: null },
    userIds: { flag: false, message: null },
    mappingFlag: { flag: false, message: null },
  });
  const [menuName, setMenuName] = useState('최상단 메뉴');
  const [hirnkNoFlag, setHirnkNoFlag] = useState(type === 'add' ? '02' : '01');
  const initExpendSeq = ['root'];
  const [expendSeq, setExpendSeq] = useState(initExpendSeq);

  const useFlagList = [
    { label: '노출', value: 'Y' },
    { label: '미노출', value: 'N' },
  ];

  const mappingList = [
    { label: '설정', value: '01' },
    { label: '해제', value: '02' },
  ];

  const hirnkNoFlagList = [
    { label: '기존 메뉴', value: '01' },
    { label: '신규 선택', value: '02' },
  ];

  useEffect(() => {
    if (type === 'modify') {
      let newModal = { ...modal };
      if (hirnkNoFlag === '01') {
        newModal = {
          ...newModal,
          params: {
            ...newModal.params,
            hirnkSeq: String(selectedMenu['hirnkSeq']),
            menuSortNo: selectedMenu['menuSortNo'],
          },
        };
      } else {
        delete newModal['params']['menuSortNo'];
      }
      handleModalData(newModal);
    } // eslint-disable-next-line
  }, [hirnkNoFlag]);

  useEffect(() => {
    if (type === 'modify') {
      if (!!selectedMenu['menuSeq']) {
        handleModalData({
          ...modal,
          params: { ...selectedMenu },
        });
        handleOpenTreeSeq(selectedMenu['hirnkSeq']);
      }
      if (!!selectedMenu['hirnkSeq']) {
        setMenuName(parentMenu['menuNm']);
      } else if (selectedMenu['hirnkSeq'] === 0) {
        setMenuName('최상단 메뉴');
      }
    } else if (type === 'delete') {
      setMenuName(selectedMenu['menuNm']);
    } else if (type === 'add') {
      handleOpenTreeSeq(selectedMenu['hirnkSeq']);
    } // eslint-disable-next-line
  }, [selectedMenu]);

  const handleOpenTreeSeq = (seq) => {
    let newExpendSeq = [...initExpendSeq];
    for (let menu of menuArray) {
      if (menu['MENU_SEQ'] === seq) {
        newExpendSeq.push(String(menu['MENU_SEQ']));
        if (menu['MENU_HIRNK_SEQ'] === 0) {
          break;
        } else {
          for (let menu2 of menuArray) {
            if (menu['MENU_HIRNK_SEQ'] === menu2['MENU_SEQ']) {
              newExpendSeq.push(String(menu2['MENU_SEQ']));
              if (menu2['MENU_HIRNK_SEQ'] === 0) {
                break;
              } else {
                for (let menu3 of menuArray) {
                  if (menu2['MENU_HIRNK_SEQ'] === menu3['MENU_SEQ']) {
                    newExpendSeq.push(String(menu3['MENU_SEQ']));
                    if (menu3['MENU_HIRNK_SEQ'] === 0) {
                      break;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    setExpendSeq(newExpendSeq);
  };

  const getParams = (newParams, name) => {
    let tempParams = newParams;
    let tempModal = { ...modal };
    if (!tempParams[name]) {
      delete tempParams[name];
    }
    tempModal = {
      ...tempModal,
      params: tempParams,
    };
    handleValidation(tempParams);
    if (tempParams['mappingFlag'] === '01') {
      tempModal['type'] = 'edit';
    } else if (tempParams['mappingFlag'] === '02') {
      tempModal['type'] = 'mappingDelete';
    }
    handleModalData(tempModal);
  };

  const renderTree = (nodes) => (
    <TreeItem key={nodes.id} nodeId={nodes.id} label={nodes.name}>
      {Array.isArray(nodes.children)
        ? nodes.children.map((node) => renderTree(node))
        : null}
    </TreeItem>
  );

  const handleHirnkNoFlag = (newFlag) => {
    if (newFlag['hirnkNo'] !== '01') {
      handleClickSnackbar({
        message: t('수정 시 메뉴 위치가 변경됩니다.'),
        option: {
          type: 'info',
        },
      });
    }
    setHirnkNoFlag(newFlag['hirnkNo']);
  };

  const handleTreeView = (e, seq) => {
    let newModalParams = { ...modal.params };
    if (type === 'add') {
      newModalParams = {
        ...newModalParams,
        hirnkSeq: seq === 'root' ? '0' : seq,
      };
    } else if (type === 'modify') {
      newModalParams = {
        ...newModalParams,
        hirnkSeq: seq === 'root' ? '0' : seq,
      };
    }
    handleModalData({
      ...modal,
      params: newModalParams,
    });
    handleValidation(newModalParams);
  };

  const handleValidation = (newParams) => {
    let returnFlag = false;
    let newError = { ...error };
    if (type === 'add' || type === 'modify') {
      // 메뉴 추가 & 메뉴 수정 유효성검사
      if (!!newParams['menuNm']) {
        newError = {
          ...newError,
          menuNm: { flag: false, message: null },
        };
      } else {
        newError = {
          ...newError,
          menuNm: { flag: true, message: t('메뉴명을 입력해주세요.') },
        };
      }
      if (!!newParams['hirnkSeq'] || newParams['hirnkSeq'] === 0) {
        newError = {
          ...newError,
          hirnkSeq: { flag: false, message: null },
        };
      } else {
        newError = {
          ...newError,
          hirnkSeq: { flag: true, message: t('위치를 선택해주세요.') },
        };
      }
      if (!!newParams['menuSortNo']) {
        if (!onlyNumberRegexp.test(newParams['menuSortNo'])) {
          newError = {
            ...newError,
            menuSortNo: {
              flag: true,
              message: t('우선순위는 숫자만 입력 가능합니다.'),
            },
          };
        } else {
          newError = {
            ...newError,
            menuSortNo: { flag: false, message: null },
          };
        }
      }
      returnFlag =
        newError['menuNm']['flag'] ||
        newError['hirnkSeq']['flag'] ||
        newError['menuSortNo']['flag'];
    } else if (type === 'userAdd') {
      // 유저 추가 유효성검사
      if (!!newParams['userIds']) {
        newError = {
          ...newError,
          userIds: { flag: false, message: null },
        };
      } else {
        newError = {
          ...newError,
          userIds: { flag: true, message: t('유저ID를 입력해주세요.') },
        };
      }
      returnFlag = newError['userIds']['flag'];
    } else if (type === 'edit' || type === 'mappingDelete') {
      if (!!newParams['mappingFlag']) {
        newError = {
          ...newError,
          mappingFlag: { flag: false, message: null },
        };
      } else {
        newError = {
          ...newError,
          mappingFlag: { flag: true, message: t('값을 선택해주세요') },
        };
      }
      returnFlag = newError['mappingFlag']['flag'];
    }
    setError(newError);
    return returnFlag;
  };

  const handleModalSubmit = () => {
    if (
      type === 'add' ||
      type === 'modify' ||
      type === 'mappingDelete' ||
      type === 'edit' ||
      type === 'userAdd'
    ) {
      if (!handleValidation(modal['params'])) {
        handleSubmit();
      }
    } else {
      handleSubmit();
    }
  };

  return (
    <Modal
      open={modal.open}
      headerOpen={modal.headerOpen}
      headerTitle={modal.modalTitle}
      handleClose={handleModalClose}
      confirmBtnTitle={modal.confirmBtnTitle}
      cancelBtnOpen={modal.cancelBtnOpen}
      cancelBtnTitle={modal.cancelBtnTitle}
      confirmOnClick={handleModalSubmit}
      useForm={type !== 'userDelete' && type !== 'delete'}
    >
      {type === 'delete' && menuName + t('를(을) 삭제하시겠습니까?')}
      {(type === 'edit' || type === 'mappingDelete') && (
        <tr>
          <th>{t('권한 부여')}</th>
          <td>
            <NewRadioGroup
              params={modal.params}
              labelKey="label"
              valueKey="value"
              optionList={mappingList}
              handleGetValue={getParams}
              name="mappingFlag"
              error={error.mappingFlag.flag}
              helperText={error.mappingFlag.message}
            />
          </td>
        </tr>
      )}
      {type === 'userAdd' && (
        <tr>
          <th>{t('유저 추가')}</th>
          <td>
            <NewInput
              type="tableInput"
              name="userIds"
              params={modal.params}
              value={modal.params['userIds']}
              callBack={getParams}
              multiline
              rows={3}
              placeholder="유저 아이디, 유저 아이디, 유저 아이디"
              error={error.userIds.flag}
              helperText={error.userIds.message}
            />
          </td>
        </tr>
      )}
      {type === 'userDelete' && '선택한 아이디 맵핑을 해제하시겠습니까?'}
      {(type === 'add' || type === 'modify') && (
        <>
          <tr>
            <th>{t('메뉴명')}</th>
            <td>
              <NewInput
                type="tableInput"
                name="menuNm"
                params={modal.params}
                value={modal.params['menuNm']}
                callBack={getParams}
                error={error.menuNm.flag}
                helperText={error.menuNm.message}
              />
            </td>
          </tr>
          <tr>
            <th>{t('위치')}</th>
            <td>
              {type !== 'add' && (
                <NewRadioGroup
                  params={{ hirnkNo: hirnkNoFlag }}
                  labelKey="label"
                  valueKey="value"
                  // selectedValue={optionSelectedValue}
                  optionList={hirnkNoFlagList}
                  handleGetValue={handleHirnkNoFlag}
                  name="hirnkNo"
                />
              )}
              {hirnkNoFlag === '02' ? (
                <>
                  <TreeView
                    defaultCollapseIcon={<ExpandMoreIcon />}
                    defaultExpanded={expendSeq}
                    // defaultExpanded={['root', '451', '516']}
                    selected={
                      type === 'add'
                        ? modal['params']['hirnkSeq']
                        : type === 'modify' &&
                          String(modal['params']['hirnkSeq'])
                    }
                    defaultExpandIcon={<ChevronRightIcon />}
                    onNodeSelect={handleTreeView}
                  >
                    {renderTree(mainMenuList)}
                  </TreeView>
                  {error['hirnkSeq']['flag'] && (
                    <p
                      style={{
                        color: theme.palette.common.red,
                        fontSize: 12,
                        borderTop: '1px solid ' + theme.palette.common.red,
                      }}
                    >
                      {t('추가할 위치를 선택해주세요.')}
                    </p>
                  )}
                </>
              ) : (
                <NewInput
                  type="tableInput"
                  params={modal.params}
                  value={menuName}
                  callBack={(f) => f}
                  disabled
                  multiline={menuName.length > 25}
                  rows={menuName.length > 25 ? 3 : 1}
                />
              )}
            </td>
          </tr>
          <tr>
            <th>{t('URL')}</th>
            <td>
              <NewInput
                type="tableInput"
                name="menuUrl"
                params={modal.params}
                value={modal.params['menuUrl']}
                callBack={getParams}
              />
            </td>
          </tr>
          <tr>
            <th>{t('우선순위')}</th>
            <td>
              <NewInput
                type="tableInput"
                name="menuSortNo"
                params={modal.params}
                value={modal.params['menuSortNo']}
                callBack={getParams}
                error={error.menuSortNo.flag}
                helperText={error.menuSortNo.message}
              />
            </td>
          </tr>
          <tr>
            <th>{t('노출여부')}</th>
            <td>
              <NewRadioGroup
                params={modal.params}
                labelKey="label"
                valueKey="value"
                optionList={useFlagList}
                handleGetValue={getParams}
                name="useYn"
              />
            </td>
          </tr>
        </>
      )}
      {type === 'view' && children}
    </Modal>
  );
};

export default MenuModal;
